import { Controller } from "react-hook-form";
import { FormControl, FormHelperText, MenuItem, OutlinedInput, Select } from "@mui/material";

import { ComponentTypes } from "./FormTypes";

export const FormSelect = ({
  control,
  helper,
  name,
  list,
  style,
  disabled
}: ComponentTypes) => {
  const checkInitialData = (data: any) =>
    Array.isArray(data) && data.length > 0 && data[0].label !== "";

  const generateSingleOptions = (list: any[]) => {
    if (!checkInitialData(list)) return [];
    return list.map((option: any) => (
      <MenuItem
        key={`${option.value}-${option.label}`}
        value={option.value}
      >
        {option.label}
      </MenuItem>
    ));
  };
  if (!list) return null;
  return (
    <Controller
      name={name}
      control={control}
      rules={helper}
      render={({
        field: { onChange, value, ref, onBlur },
        fieldState: { error },
      }) => (
        <>
          <FormControl required>
            <Select
             displayEmpty
             input={<OutlinedInput />}
             inputProps={{ 'aria-label': 'Without label' }}
              required={true}
              error={error !== undefined}
              onChange={(e) => {
                onChange(e);
              }}
              value={value || ""}
              onBlur={onBlur}
              inputRef={ref}
              label="MFA Preference"
              sx={style}
              disabled={disabled}
            >
              <MenuItem disabled value={""}>
                Choose
              </MenuItem>
              {generateSingleOptions(list)}
            </Select>
            {helper && helper.required && helper.required.value && (
              <FormHelperText>{error ? error.message : null}</FormHelperText>
            )}
          </FormControl>
        </>
      )}
    />
  );
};
